import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
import MobileDetect from 'mobile-detect';
import ButtonUnderstood from 'components/documentationInfo/ButtonUnderstood';

class TraditionalSuccess extends Component {
    UNSAFE_componentWillMount = () => {
        window.scrollTo(0, 0);
    };

    render = () => {
        const {
            userProfile: { name },
        } = this.props;
        const md = new MobileDetect(navigator.userAgent);

        return (
            <div className="documentation-info-view">
                <div className="prospects-gutter prospects-prepend-margin basic-layering fix-margin-top">
                    <div className="messages-container documentation-info-view__congrats">
                        <div className="icon-container">
                            <i className="icons icons--icon-success-blue" />
                        </div>
                        <div className="text-container">
                            <h2 className="font-heading2">
                                <FormattedText value="documentation-congratulations" injectedStrings={[name]} />
                            </h2>
                            <span className="dash-blue" />
                            <FormattedText value="documentation-congratulationsSuccessTraditional" />
                        </div>
                    </div>
                </div>
                <div className="row" style={{ ...(md.phone() && { width: '100%', margin: 0 }) }}>
                    <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 transfer-info__step basic-layering messages-container documentation-info-view__congrats"
                        style={{
                            ...(md.phone() && {
                                paddingRight: 20,
                                paddingLeft: 20,
                                marginBottom: 15,
                                marginTop: 30,
                            }),
                            ...(!md.phone() && {
                                width: 370,
                                minHeight: 300,
                                paddingRight: 30,
                                paddingLeft: 30,
                                marginLeft: 15,
                                marginTop: 25,
                                marginBottom: 25,
                            }),
                        }}
                    >
                        <h3 className="font-heading3">
                            <FormattedText value="documentation-cuentaCorrienteTraditional" />
                        </h3>
                        <span className="dash-blue" />
                        <ul>
                            <li>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-cuentaCorrienteTraditionalItem1" />
                                </div>
                            </li>
                            <li>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-cuentaCorrienteTraditionalItem2" />
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 transfer-info__step basic-layering messages-container documentation-info-view__congrats"
                        style={{
                            ...(md.phone() && {
                                paddingRight: 20,
                                paddingLeft: 20,
                                marginTop: 15,
                                marginBottom: 30,
                            }),
                            ...(!md.phone() && {
                                minHeight: 300,
                                paddingRight: 30,
                                paddingLeft: 30,
                                width: 370,
                                float: 'right',
                                marginRight: 15,
                                marginTop: 25,
                                marginBottom: 25,
                            }),
                        }}
                    >
                        <h3 className="font-heading3">
                            <FormattedText value="documentation-tarjetaOpenDebitTraditional" />
                        </h3>
                        <span className="dash-blue" />
                        <ul>
                            <li>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-tarjetaOpenDebitTraditionalItem1" />
                                </div>
                            </li>
                            <li>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-tarjetaOpenDebitTraditionalItem2" />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="prospects-gutter prospects-prepend-margin basic-layering">
                    <div className="documentation-info-view__further">
                        <h3 className="font-heading3">
                            <FormattedText value="documentation-furtherTraditional" />
                        </h3>
                        <span className="dash-blue" />
                        <ul>
                            <li>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-furtherSuccessTraditionalItem1Text" />
                                </div>
                            </li>
                            <li>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-furtherSuccessTraditionalItem2Text" />
                                </div>
                            </li>
                            <li>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-furtherSuccessTraditionalItem3Text" />
                                </div>
                            </li>
                        </ul>
                    </div>
                    <hr />
                    <Fragment>
                        <div className="documentation-info-view__contact">
                            <i className="icons icons--icon-phone-blue"></i>
                            <p className="font-paragraph2">
                                <strong className="title">
                                    <FormattedText value="documentation-contactTitleTraditional" />
                                </strong>
                                <br />
                                <FormattedText value="documentation-contactTraditionalTextPart1" />
                                <a className="aBlue" href={formatText('documentation-contactMailToTraditional')}>
                                    <FormattedText value="documentation-contactEmailTraditional" />
                                </a>
                                <FormattedText value="documentation-contactTraditionalTextPart2" />
                            </p>
                        </div>
                    </Fragment>
                </div>
                <ButtonUnderstood />
            </div>
        );
    };
}

export default connect(state => ({ userProfile: state.userProfile }))(TraditionalSuccess);
